import { takeLatest, call, put } from 'redux-saga/effects'
import { GET_USERS } from './actionTypes'
import { setLoader } from '../loader/actions'
import userService from '../../supabaseServices/UserService'
import { setUsers } from './actions'

export function* getUsersSagaFn(payload) {
  try {
    yield put(setLoader(true))
    const res = yield call(userService.getPaginatedUsers, 1)
    yield put(setUsers(res))
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoader(false))
  }
}

export default function* userSaga() {
  yield takeLatest(GET_USERS, getUsersSagaFn)
}
